import { UPLOAD_ASSET_KIND_VALUES } from "@fysaro/domain";
import { z } from "zod";

const uploadAssetSchema = z
  .object({
    clinicId: z.string().uuid(),
    assetKind: z.enum(UPLOAD_ASSET_KIND_VALUES),
    entityId: z.string().min(1),
  })
  .strict();

export const getUploadSignatureSchema = uploadAssetSchema.extend({
  mimeType: z.string(),
});

export const deleteCloudinaryImage = uploadAssetSchema;
